jQuery(function ($) {
	var windowWidth = window.innerWidth;
	var body = 'body';
	var $window = $(window);
	
	/*--------------------------------------------------------------
	# Hamburger Menu
	--------------------------------------------------------------*/
	var menuBtn = '[data-menu-btn]';
	var mainNav = '[data-main-nav]';
	
	$(menuBtn).on('click', function () {
		$(this).toggleClass('open');
		$(mainNav).toggleClass('slide-in-nav');
		$(body).toggleClass('overlay');
	});
	
	// Dropdown menu transition
	var $parentLink = $(mainNav).find('.menu-item-has-children');
	$parentLink.hover(function () {
		var $childMenu = $(this).children('.sub-menu');
		if ($childMenu.is(':visible')) {
			$childMenu.fadeOut('fast');
		} else {
			$childMenu.fadeIn('fast');
		}
	},
		function () {
			$(this).find('.sub-menu').fadeOut('fast');
		});
	
	/*--------------------------------------------------------------
	# Slick Slider
	--------------------------------------------------------------*/

	$('[data-main-slider]').slick({
		prevArrow: $('[data-main-left]'),
		nextArrow: $('[data-main-right]'),
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		dots: false,
		fade: true
	});

	$('[data-players-slider]').slick({
		prevArrow: $('[data-players-left]'),
		nextArrow: $('[data-players-right]'),
		infinite: true,
		slidesToShow: 4,
		rows: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		dots: false,
		//fade: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 899,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
	});

	$('[data-news-slider]').slick({
		prevArrow: $('[data-news-left]'),
		nextArrow: $('[data-news-right]'),
		infinite: true,
		slidesToShow: 2,
		rows: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		dots: false,
		//fade: true,
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
	});

    $('[data-player-gallery-slider]').slick({
		arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1, 
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: true,
        customPaging: function () {
            return '';
        }
    });

	/*--------------------------------------------------------------
	# Smooth Scroll
	--------------------------------------------------------------*/
	// var scrollTime = .6;
	// var scrollDistance = 300;
	//
	// $window.on("mousewheel DOMMouseScroll", function(event) {
	//     event.preventDefault();
	//
	//     var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
	//     var scrollTop = $window.scrollTop();
	//     var finalScroll = scrollTop - parseInt(delta*scrollDistance);
	//
	//     TweenLite.to($window, scrollTime, {
	//         scrollTo : { y: finalScroll, autoKill:true },
	//         ease: Power1.easeOut,
	//         overwrite: 5
	//     });
	// });
	


	/*--------------------------------------------------------------
	# Parallax
	--------------------------------------------------------------*/

	var windowWidth = window.innerWidth;

	function new_parallax(selector, speed, offset) {

	  if (windowWidth > 1023) {

		  if (selector.length !== 0 ) {

		    var sectionOffset = selector.offset().top;
		    var scrolled = $(window).scrollTop() - sectionOffset;
		    var sectionPosition = (scrolled * speed + offset)  + 'px';
		    selector.attr('style', 'top:' + sectionPosition);

		  }

	  }

	}

	// Start function

	$(window).scroll(function(){

		$('.square-1').each(function () {
			new_parallax($(this), .3, 450);
		});

		$('.square-2').each(function () {
			new_parallax($(this), .2, 200);
		});

		$('.square-3').each(function () {
			new_parallax($(this), .1, 400);
		});

		$('.shape-1').each(function () {
			new_parallax($(this), .2, 300);
		}); 

		$('.shape-2').each(function () {
			new_parallax($(this), .2, 700);
		}); 

		$('.shape-3').each(function () {
			new_parallax($(this), .2, 1400);
		});

		$('.shape-4').each(function () {
			new_parallax($(this), .2, 2000);
		});



		$('.home .square-1').each(function () {
			new_parallax($(this), .2, 600);
		});

		$('.home .square-2').each(function () {
			new_parallax($(this), .3, 250);
		});

		$('.home-shape-1').each(function () {
			new_parallax($(this), .2, 200);
		}); 

		$('.home-shape-2').each(function () {
			new_parallax($(this), .2, 300);
		}); 

		$('.home-shape-3').each(function () {
			new_parallax($(this), .2, 200);
		});

		$('.home-shape-4').each(function () {
			new_parallax($(this), .2, 400);
		});

	});

    function parallaxBackground(selector, speed) {
        var paraHomeCall = $(selector);
        [].slice.call(paraHomeCall).forEach(function(el,i) {
            var windowYOffset = window.pageYOffset
            var elBackgrounPos = "center " + (windowYOffset * speed) + "px";
            paraHomeCall.css({'background-position' : elBackgrounPos});
        });
    };

	$(window).on('scroll', function() {  
	    parallaxBackground('.main-slider .slide', 0.2);
	    parallaxBackground('.page-header', 0.2);    
	});


    /*--------------------------------------------------------------
    # WOW
    --------------------------------------------------------------*/

    function afterReveal( el ) {
        el.addEventListener('animationend', function( event ) {
            $('.wow').each(function(){ $(this).css('opacity',1); 
                }); 
            }); 
    } 
    new WOW({ callback: afterReveal }).init() 

    
	/*--------------------------------------------------------------
	# Accordion
	--------------------------------------------------------------*/

	var allPanels = $('.accordion > dd').hide();
	var allTabs = $('.accordion > dt');

	$('.accordion > dt').click(function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open').next().slideUp();
		} else {
			allPanels.slideUp();
			allTabs.removeClass('open');
			$(this).addClass('open').next().slideDown();
		}
	});


    /*--------------------------------------------------------------
	 ## Responsive menu
	 --------------------------------------------------------------*/

    $('.menu-btn').click(function() {

        if ($('.menu-btn').hasClass('btn-opened')) {

            $(this).removeClass('btn-opened');
            $('.main-navigation').removeClass('nav-opened');
        }

        else {
            $(this).addClass('btn-opened');
            $('.main-navigation').addClass('nav-opened');
        }
    });

	/*--------------------------------------------------------------
	# Other
	--------------------------------------------------------------*/

	setTimeout(function () {
		$('.main-slider .arrow').css('opacity', 1);
	}, 100);


    lightbox.option({
        'albumLabel': "Slika %1 od %2"
    })

});
